import ApostleAttachReforgeTabs from '@src/components/apostles/manage/ApostleAttachReforgeTabs'
import ApostleAttachView from '@src/components/apostles/manage/attach/ApostleAttachView'
import SanctuarySecNavBar from '@src/components/navigationBar/secondary/SanctuarySecNavBar'
import { ApostleAttachProvider } from '@src/contexts/apostle/ApostleAttachContext'
import { ApostleSkillsProvider } from '@src/contexts/apostle/ApostleSkillsContext'
import { PlanetTypeProvider } from '@src/contexts/planet/PlanetTypeContext'
import { useSecondaryNavBarContext } from '@src/contexts/share/SecondaryNavBarContext'
import type { NextPage } from 'next'
import { useEffect } from 'react'

const ApostleAttachPage: NextPage = () => {
  const { setupBar } = useSecondaryNavBarContext()

  useEffect(() => {
    setupBar(<SanctuarySecNavBar index={1} />)

    return () => setupBar(null)
  }, [setupBar])

  return (
    <PlanetTypeProvider>
      <ApostleSkillsProvider>
        <ApostleAttachProvider>
          <ApostleAttachReforgeTabs navbarIndex={'0'}>
            <ApostleAttachView />
          </ApostleAttachReforgeTabs>
        </ApostleAttachProvider>
      </ApostleSkillsProvider>
    </PlanetTypeProvider>
  )
}

export default ApostleAttachPage
